import React from 'react';
import BeRemoteErrorAlert from 'client/components/Be/BeRemoteErrorAlert';
import propTypes from 'prop-types';
import EndpointSnowForm from 'client/components/Endpoint/EndpointSnowForm';
import { connect } from 'react-redux';
import * as snowActions from 'client/redux/endpoint/snow/actions';
import BeLoading from 'client/components/Be/BeLoading';
import { getResponseToFormErrorHandler } from 'client/redux/apiHelpers';
import { HelpButton } from 'client/components/Helpers/Help';
import UIFragmentHelpModal from 'client/components/UIFragment/UIFragmentHelpModal';
import { AlertWithMessage } from 'client/components/Be/Alert';
import EndpointTestButton from 'client/components/Endpoint/components/EndpointTestButton';

class EndpointSnow extends React.Component {

  static defaultProps = {
    onUpdated: function () {},
  };

  static propTypes = {
    endpointId: propTypes.string.isRequired,
    instanceId: propTypes.string.isRequired,
    preloadedEndpoint: propTypes.object,
    onUpdated: propTypes.func,
  };

  componentDidMount () {
    if (this.props.preloadedEndpoint) {
      this.props.endpointSnowPreloaded(this.props.preloadedEndpoint);
    } else {
      this.props.endpointSnowRead(this.props.endpointId);
    }
  }

  componentDidUpdate (prevProps) {
    const { endpointId } = this.props;
    if (endpointId !== prevProps.endpointId) {
      this.props.endpointSnowRead(endpointId);
    }
    if (this.props.endpoint?.status !== prevProps.endpoint?.status) {
      this.props.onUpdated(endpointId);
    }
  }

  handleUpdate = (settings = {}) => {
    return this.props.endpointSnowUpdateSettings(this.props.endpointId, settings)
      .then(getResponseToFormErrorHandler())
      .then(result => {
        this.props.endpointSnowEditSettings(false);
      });
  };

  handleClickEdit = ev => {
    this.props.endpointSnowEditSettings(true);
  };

  handleTest = ev => {
    const { endpointId } = this.props;
    return this.props.endpointSnowTest(endpointId);
  };

  dataToFields (data = {}) {
    return {
      apiUrl: data.apiUrl || '',
      clientId: data.clientId || '',
      clientSecret: data.clientSecret || '',
    };
  }

  render () {
    const {
      endpoint,
      error,
      isEditing,
      isReading,
      isUpdating,
      isTesting,
      isSetupMode,
    } = this.props;

    const endpointHasError = endpoint?.status === 'error';

    return (
      <div>
        <div className="form-group">
          <h3 className="wizard-title">
            <div className="clearfix">
              Snow Atlas
              <HelpButton
                className="btn btn-rounded btn-default btn-xs pull-right"
                HelpModal={UIFragmentHelpModal}
                helpModalProps={{fragmentId: 'endpoint_snow_settings_help'}}
              />
            </div>
            <span className="panel-subtitle">Enter and test your Snow credentials below</span>
          </h3>
        </div>
        <div className="well xs-mb-10 xs-p-0">
          <BeLoading loading={isReading} className="xs-p-20">
            <BeRemoteErrorAlert error={error} ignoreValidationResult={true} /> 
            {endpointHasError && (
              <AlertWithMessage icon={true} className="alert-icon" alertType="warning">
                <strong>Error:</strong> There is a problem with this endpoint.
              </AlertWithMessage>
            )}
            {endpoint && (
              <>
                {isEditing || isSetupMode ? (
                  <EndpointSnowForm
                    initialValues={this.dataToFields(endpoint.settings)}
                    isEditing={isEditing}
                    isTesting={isTesting}
                    endpointState={endpoint.state}
                    onEdit={this.handleClickEdit}
                    onTest={this.handleTest}
                    onSubmit={this.handleUpdate}
                    isUpdating={isUpdating}
                    remoteError={error}
                  />
                ) : (
                  <>
                    {!isEditing && (
                      <div className="row">
                        <div className="col-md-6">
                          <EndpointTestButton
                            isTesting={isTesting}
                            onTest={this.handleTest}
                            testOk={endpoint.state.testOk}
                            testTimestamp={endpoint.state.testTimestamp}
                          />
                        </div>
                        <div className="col-md-6">
                          <div className="btn-group pull-right clearfix">
                            <button
                              type="button"
                              className="btn btn-default"
                              onClick={this.handleClickEdit}
                            >
                              <i className="icon icon-left mdi mdi-edit"></i>
                              {' '}Edit credentials
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </BeLoading>
        </div>
      </div>
    );
  }

}

export default connect(state => state.endpoint.snow, snowActions)(EndpointSnow);
